import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph } from 'components/core/Typography';

export default function ReviewTitle({ reviewTitle }) {
	return (
		<Paragraph className="review-title" size="small">
			{reviewTitle}
		</Paragraph>
	);
}

ReviewTitle.propTypes = {
	/** Title of the review */
	reviewTitle: PropTypes.string.isRequired
};
